import React, { useState } from 'react';
import {
  FDBodyText,
  FDHeadlineText,
  FDPaper, FDSecondaryActionButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ManagedAccountPortfolioBarChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/PortfolioSection/ManagedAccountPortfolioBarChart';
import useMobileLayout from 'Hooks/useMobileLayout';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { dataAttrs } from 'Helpers/Testing';
import { convertChartDataCollectionToObjectArray } from '../OutcomeInvestmentDetailsOverview/OutcomeInvestmentDetailsOverviewLayout';
import { OutcomeInvestmentDetailsAccountDetailsSection } from '../OutcomeInvestmentDetailsAccountDetailsSection/OutcomeInvestmentDetailsAccountDetailsSection';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => FDTitleText,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('expenseRatio', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

const OutcomeInvestmentDetailsAccountLayout = ({ onViewDetails }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const allocationMixChartData = convertChartDataCollectionToObjectArray(resource?.attr('allocationClassificationData'));

  return (
    // 272 width comes from a 600px container with 16px padding on each side and a 24px gap between (600 - (16 * 2) - 24) / 2 = 272
    <FDPaper padding={2} width={isMobile ? '100%' : 272} {...dataAttrs('investment-details-account-layout')}>
      <FDStack direction={'column'} spacing={2} width={'100%'}>
        <MetaControlField attr={'name'} />
        <ManagedAccountPortfolioBarChart
          allocationModelClassifications={allocationMixChartData}
          simple
          skinny
        />
        <FDSecondaryActionButton label={'View account'} onClick={() => onViewDetails(resource)} {...dataAttrs('view-account-button')} />
      </FDStack>
    </FDPaper>
  );
};

const OutcomeInvestmentDetailsAccountsLayout = ({ collection }) => {
  const [accountDetails, setAccountDetails] = useState(null);

  const handleBack = () => {
    setAccountDetails(null);
  };

  const handleViewDetails = (accountDetailsRes) => {
    setAccountDetails(accountDetailsRes);
  };

  if (accountDetails) {
    const allocationMixChartData = convertChartDataCollectionToObjectArray(accountDetails?.attr('allocationClassificationData'));
    const tickerMixChartData = convertChartDataCollectionToObjectArray(accountDetails?.attr('tickerClassificationData'));

    return (
      <MetaResourceRenderer
        resource={accountDetails}
        metaOverrideSet={metaOverrideSet}
        layout={() => (
          <OutcomeInvestmentDetailsAccountDetailsSection
            tickerMixChartData={tickerMixChartData}
            allocationMixChartData={allocationMixChartData}
            onBack={handleBack}
          />
        )}
      />
    );
  }

  return (
    <FDStack spacing={3} wrap>
      <MetaCollectionRenderer
        collection={collection}
        layout={OutcomeInvestmentDetailsAccountLayout}
        metaOverrideSet={metaOverrideSet}
        LayoutProps={{
          onViewDetails: handleViewDetails,
        }}
      />
    </FDStack>
  );
};

export { OutcomeInvestmentDetailsAccountsLayout };
